'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('angular');

require('ionic');

require('font-awesome');

require('../../../../vui/src/css/common.scss');

require('../../../../vui/src/css/grid.scss');

require('../../../../vui/src/css/row.scss');

require('../../../../vui/src/css/list.scss');

require('../../../../vui/src/css/item.scss');

require('../../../../vui/src/css/card.scss');

require('./app.module.scss');

var _app = require('./app.controllers');

var _app2 = _interopRequireDefault(_app);

var _EVENTS = require('./EVENTS');

var _EVENTS2 = _interopRequireDefault(_EVENTS);

var _global = require('./global');

var _global2 = _interopRequireDefault(_global);

var _USER_ROLES = require('./USER_ROLES');

var _USER_ROLES2 = _interopRequireDefault(_USER_ROLES);

var _BACK_PRIORITY = require('./BACK_PRIORITY');

var _BACK_PRIORITY2 = _interopRequireDefault(_BACK_PRIORITY);

var _session = require('./session');

var _session2 = _interopRequireDefault(_session);

var _index = require('../lib/angular1.x-common/directives/validationMessage/index');

var _index2 = _interopRequireDefault(_index);

var _blurDeleteAll = require('../lib/angular1.x-common/directives/blurDeleteAll');

var _blurDeleteAll2 = _interopRequireDefault(_blurDeleteAll);

var _focusMe = require('../lib/angular1.x-common/directives/focusMe');

var _focusMe2 = _interopRequireDefault(_focusMe);

var _httpInterceptors = require('../lib/angular1.x-common/services/httpInterceptors');

var _httpInterceptors2 = _interopRequireDefault(_httpInterceptors);

var _linked = require('../lib/angular1.x-common/directives/linked');

var _linked2 = _interopRequireDefault(_linked);

var _elementInit = require('../lib/angular1.x-common/directives/elementInit');

var _elementInit2 = _interopRequireDefault(_elementInit);

var _preventDefault = require('../lib/angular1.x-common/directives/preventDefault');

var _preventDefault2 = _interopRequireDefault(_preventDefault);

var _currentScope = require('../lib/angular1.x-common/services/currentScope');

var _currentScope2 = _interopRequireDefault(_currentScope);

var _imagePreload = require('../lib/angular1.x-common/services/imagePreload');

var _imagePreload2 = _interopRequireDefault(_imagePreload);

var _localStorage = require('../lib/angular1.x-common/services/localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

var _loadImage = require('../lib/angular1.x-common/services/loadImage');

var _loadImage2 = _interopRequireDefault(_loadImage);

var _$qWhen = require('../lib/angular1.x-common/services/$qWhen');

var _$qWhen2 = _interopRequireDefault(_$qWhen);

var _aMap = require('../lib/ionic1.x-common/services/aMap');

var _aMap2 = _interopRequireDefault(_aMap);

var _index3 = require('../lib/ionic1.x-common/services/alert/index');

var _index4 = _interopRequireDefault(_index3);

var _clientInfo = require('../lib/ionic1.x-common/services/clientInfo');

var _clientInfo2 = _interopRequireDefault(_clientInfo);

var _imageLazyLoad = require('../lib/ionic1.x-common/directives/imageLazyLoad');

var _imageLazyLoad2 = _interopRequireDefault(_imageLazyLoad);

var _index5 = require('../lib/ionic1.x-common/services/selectModal/index');

var _index6 = _interopRequireDefault(_index5);

var _sqLite = require('../lib/ionic1.x-common/services/sqLite');

var _sqLite2 = _interopRequireDefault(_sqLite);

var _pickerview = require('../lib/ionic1.x-common/services/pickerview');

var _pickerview2 = _interopRequireDefault(_pickerview);

var _baseModal = require('../lib/ionic1.x-common/services/baseModal');

var _baseModal2 = _interopRequireDefault(_baseModal);

var _index7 = require('../lib/ionic1.x-common/directives/viewIntercept/index');

var _index8 = _interopRequireDefault(_index7);

var _scrollDelegate = require('../lib/ionic1.x-common/services/scrollDelegate');

var _scrollDelegate2 = _interopRequireDefault(_scrollDelegate);

var _viewRefresh = require('../lib/ionic1.x-common/directives/viewRefresh');

var _viewRefresh2 = _interopRequireDefault(_viewRefresh);

var _goScrollTop = require('../lib/ionic1.x-common/directives/goScrollTop');

var _goScrollTop2 = _interopRequireDefault(_goScrollTop);

var _index9 = require('../lib/ionic1.x-common/services/loading/index');

var _index10 = _interopRequireDefault(_index9);

var _app3 = require('./app.config');

var _app4 = _interopRequireDefault(_app3);

var _app5 = require('./app.run');

var _app6 = _interopRequireDefault(_app5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 导入第三方模块
var app = angular.module('starter', ['ionic']);

// register controllers


// css

(0, _app2.default)(app);

// register modules

(0, _EVENTS2.default)(app);

(0, _global2.default)(app);

(0, _USER_ROLES2.default)(app);

(0, _BACK_PRIORITY2.default)(app);

(0, _session2.default)(app);

(0, _index2.default)(app);

// register angular1.x-common
/*import ValidationMessage from '../lib/angular1.x-common/directives/validationMessage/index';
ValidationMessage(app);*/

(0, _blurDeleteAll2.default)(app);

(0, _focusMe2.default)(app);

(0, _httpInterceptors2.default)(app);

(0, _linked2.default)(app);

(0, _elementInit2.default)(app);

(0, _preventDefault2.default)(app);

(0, _currentScope2.default)(app);

(0, _imagePreload2.default)(app);

(0, _localStorage2.default)(app);

(0, _loadImage2.default)(app);

(0, _$qWhen2.default)(app);

// register ionic1.x-common

(0, _aMap2.default)(app);

(0, _index4.default)(app);

(0, _clientInfo2.default)(app);

(0, _imageLazyLoad2.default)(app);

(0, _index6.default)(app);

(0, _sqLite2.default)(app);

(0, _pickerview2.default)(app);

(0, _baseModal2.default)(app);

(0, _index8.default)(app);

(0, _scrollDelegate2.default)(app);

(0, _viewRefresh2.default)(app);

(0, _goScrollTop2.default)(app);

(0, _index10.default)(app);

// app config run
// ---------------------------------------------------------------------------------------------------------------------

(0, _app4.default)(app);

(0, _app6.default)(app);

exports.default = app;


//////////////////
// WEBPACK FOOTER
// ./src/app/app.module.js
// module id = 2
// module chunks = 0